<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <!--Vertical y horizontal-->
          <v-flex xs12 sm8>
            <v-card class="elevation-12">
              <v-tabs color="blue" dark grow slider-color="yellow">
                <v-tab ripple to="/config/profile">
                  Perfil
                </v-tab>
                <v-tab ripple to="/config/account">
                  Cuenta
                </v-tab>
              </v-tabs>
              <v-toolbar dark color="primary">
                <v-toolbar-title>Editar perfil público</v-toolbar-title>
              </v-toolbar>
              <v-card-text v-if="loading">
                Cargando...
                <v-progress-linear
                  indeterminate
                  color="blue"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
              <v-alert v-if="notfound" :value="true" type="error" color="red">
                Perfil no encontrado.
              </v-alert>
              <form
                @submit.prevent="changeProfileInfo"
                v-if="!loading && !notfound"
              >
                <v-card-text>
                  <v-layout wrap align-center justify-center>
                    <v-flex xs12 md4 text-xs-center>
                      <v-card-text class="">
                        Foto de perfil
                      </v-card-text>
                      <v-avatar size="150" color="grey lighten-4">
                        <img
                          v-show="!procesandoImagen"
                          id="photo"
                          :src="userPhoto"
                          alt="avatar"
                        />
                        <v-progress-circular
                          indeterminate
                          color="blue"
                          class="mb-0"
                          size="100"
                          width="8"
                          v-if="procesandoImagen"
                        />
                      </v-avatar>
                      <br />
                      <br />
                      <input
                        v-show="false"
                        ref="inputUpload"
                        type="file"
                        accept="image/*"
                        @change="changePhoto"
                      />
                      <v-btn
                        @click="$refs.inputUpload.click()"
                        color="indigo"
                        dark
                        :loading="procesandoImagen"
                      >
                        <v-icon dark left>cloud_upload</v-icon>Subir
                      </v-btn>
                      <v-btn
                        @click="deletePhoto"
                        :disabled="noUserPhoto"
                        color="red"
                        outline
                        :loading="procesandoImagen && !noUserPhoto"
                      >
                        <v-icon dark left>delete</v-icon>Borrar
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 md8>
                      <v-text-field
                        required
                        outline
                        id="name"
                        name="name"
                        label="Nombre"
                        v-model="name"
                        type="text"
                        counter
                        maxlength="70"
                      ></v-text-field>
                      <v-text-field
                        readonly
                        outline
                        color="secondary"
                        id="username"
                        name="username"
                        label="Nombre de usuario"
                        v-model="userName"
                        type="text"
                        hint="No se puede cambiar."
                        persistent-hint
                      ></v-text-field>
                      <v-text-field
                        readonly
                        outline
                        color="secondary"
                        id="email"
                        name="email"
                        label="Correo electrónico"
                        v-model="email"
                        type="email"
                        hint="Puedes cambiar el email verificado en los ajustes de la cuenta."
                        persistent-hint
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <br />
                  <v-textarea
                    flat
                    auto-grow
                    outline
                    name="description"
                    label="Descripción"
                    v-model="description"
                    counter
                    maxlength="500"
                  ></v-textarea>
                  <v-btn color="primary" type="submit" :disabled="deshabilitar">
                    Actualizar perfil
                  </v-btn>
                </v-card-text>
              </form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from "firebase";

let firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
    authDomain: "tfgr-9ed26.firebaseapp.com",
    databaseURL: "https://tfgr-9ed26.firebaseio.com",
    projectId: "tfgr-9ed26",
    storageBucket: "tfgr-9ed26.appspot.com",
    messagingSenderId: "47742064305"
  });
} else {
  firebaseApp = firebase.app();
}
export const db = firebaseApp.database();

//Configuración de un perfil de usuario
// @group Configurar usuario
export default {
  data() {
    return {
      procesando: false,
      procesandoImagen: false,
      loading: true,
      notfound: false,
      name: "",
      description: "",
      imageName: "",
      imageUrl: "",
      imageFile: "",
      datosUsuario: {
        dateLastLogIn: "dateLastLogIn",
        dateSignUp: "dateSignUp",
        description: "description",
        email: "email",
        language: "language",
        name: "name",
        uid: "uid",
        username: "username"
      }
    };
  },
  created() {
    this.$bindAsArray(
      "arrayDatos",
      db
        .ref("users")
        .orderByChild("uid")
        .equalTo(this.$store.state.user.uid)
        .limitToFirst(1),
      snap => {
        if (this.arrayDatos.length === 0) {
          this.notfound = true;
        } else {
          this.name = this.arrayDatos[0].name;
          this.description = this.arrayDatos[0].description;
          this.datosUsuario = this.arrayDatos[0];
        }
        this.loading = false;
      },
      error => {
        if (this.arrayDatos.length === 0) {
          this.notfound = true;
        } else {
          this.name = this.arrayDatos[0].name;
          this.description = this.arrayDatos[0].description;
          this.datosUsuario = this.arrayDatos[0];
        }
        this.loading = false;
      }
    );
  },
  methods: {
    // @vuese
    // Cambiar datos del perfil
    // @arg Nombre y descripción
    changeProfileInfo() {
      this.procesando = true;
      this.$store.dispatch("changeProfileInfo", {
        name: this.name.trim(),
        description: this.description.trim(),
        uid: this.$store.state.user.uid
      });
      this.procesando = false;
      alert("Perfil cambiado con éxito");
    },
    // @vuese
    // Cambiar foto del perfil
    // @arg Foto
    changePhoto(e) {
      this.procesandoImagen = true;
      let files = e.target.files;
      if (e.target.files[0] !== undefined) {
        this.imageName = e.target.files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        let fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = e.target.files[0]; // this is an image file that can be sent to server...
          let storageRef = firebase
            .storage()
            .ref(
              "users/" + this.$store.state.user.uid + "/" + new Date().toJSON()
            );
          let self = this;
          storageRef
            .put(this.imageFile)
            .then(function() {
              let uid = self.$store.state.user.uid;
              storageRef
                .getDownloadURL()
                .then(function(url) {
                  // `url` is the download URL for 'images/stars.jpg'
                  firebase
                    .database()
                    .ref("users/" + uid)
                    .update({
                      photo: url
                    });
                  let img = document.getElementById("photo");
                  img.src = url;
                  self.arrayDatos[0].photo = url;
                  self.procesandoImagen = false;
                })
                .catch(function(error) {
                  // Handle any errors
                  self.procesandoImagen = false;
                });
            })
            .catch(function(error) {
              // Handle any errors
              self.procesandoImagen = false;
            });
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
        this.procesandoImagen = false;
      }
    },
    // @vuese
    // Borrar foto del perfil
    deletePhoto() {
      this.procesandoImagen = true;
      if (confirm("¿Estás seguro de que quieres borrar tu foto?")) {
        const uid = this.$store.state.user.uid;
        firebase
          .database()
          .ref("users/" + uid)
          .update({
            photo: null
          });
      }
      this.procesandoImagen = false;
    }
  },
  computed: {
    // @vuese
    // Extrae la foto del usuario
    userPhoto() {
      if (this.procesandoImagen) {
        return "/img/loop.svg";
      }
      if (
        this.arrayDatos[0] === null ||
        this.arrayDatos[0] === undefined ||
        this.arrayDatos[0].photo === null ||
        this.arrayDatos[0].photo === undefined
      ) {
        return "/img/user.svg";
      } else {
        return this.arrayDatos[0].photo;
      }
    },
    // @vuese
    // Indica si el usuario no tiene foto
    noUserPhoto() {
      if (
        this.arrayDatos[0] === null ||
        this.arrayDatos[0] === undefined ||
        this.arrayDatos[0].photo === null ||
        this.arrayDatos[0].photo === undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
    // @vuese
    // Deshabilita el botón de modificar si no hay cambios
    deshabilitar() {
      if (this.arrayDatos[0] === null || this.arrayDatos[0] === undefined) {
        return this.procesando;
      } else {
        return this.procesando || !(this.arrayDatos[0].name !== this.name || this.arrayDatos[0].description !== this.description);
      }
    },
    // @vuese
    // Devuelve el nombre de usuario
    userName() {
      if (this.datosUsuario.username != null) {
        return this.datosUsuario.username;
      } else {
        return "userName";
      }
    },
    // @vuese
    // Devuelve el email del usuario
    email() {
      return this.$store.state.user.email;
    },
    emailVerified() {
      return this.$store.state.user.emailVerified;
    }
  }
};
</script>
